import { Injectable } from '@angular/core';
import { RestService } from "../core/core/rest.service";
import { ObjectToSelect } from "../core/shared/objectToSelect.model";
import { NumeratorType, Numerator } from './numerator.model';

@Injectable()
export class NumeratorRest {

  constructor(private http: RestService) { }

  public getTypes(numeratorType: NumeratorType){
    return this.http.post<ObjectToSelect[]>('api/numerator/gettypes', numeratorType);
  }

  public getSeries(numeratorType: NumeratorType){
    return this.http.post<ObjectToSelect[]>('api/numerator/getseries', numeratorType);
  }

  public getLastNumber(numerator: Numerator){
    return this.http.post<Number>('api/numerator/getlastnumber', numerator);
  }
}
